<script setup>
import { computed, provide } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import AppShell from '@/components/layout/AppShell.vue'
import UiToasts from '@/components/ui/UiToasts.vue'
import UiConfirm from '@/components/ui/UiConfirm.vue'
import MissingFieldsDialog from '@/components/dialogs/MissingFieldsDialog.vue'
import UiTooltips from '@/components/ui/UiTooltips.vue'
import PrivacyLayer from '@/components/privacy/PrivacyLayer.vue'
import { DATETIME } from '@addictivegroup/addictive-datetime'
import { useUi } from '@/stores/ui.js'
import { useSession } from '@/stores/session.js'

const route = useRoute()
const { t, locale } = useI18n()
// addictive-offline components translate through this (keys offline.*).
provide('offlineT', t)
provide('docviewT', t)
// …and ask through the application's own confirmation dialog, never the browser's.
const ui = useUi()
provide('offlineConfirm', (options) => ui.ask(options))
// Date and time fields: in the interface's language, on the person's clock (their zone, the
// hour they start work), drawn as the application's own inputs.
const session = useSession()
provide(DATETIME, computed(() => ({
  locale: locale.value === 'en' ? 'en-GB' : 'pl-PL',
  timeZone: session.me?.time_zone || undefined,
  dayStart: session.me?.settings?.work_start || '08:00',
  inputClass: 'input',
  invalidClass: 'invalid',
})))
const bare = computed(() => route.meta.bare === true)
</script>

<template>
  <div v-if="bare" class="flex min-h-full items-center justify-center p-4">
    <router-view />
  </div>
  <AppShell v-else>
    <router-view v-slot="{ Component }">
      <component :is="Component" :key="$route.fullPath.split('?')[0]" />
    </router-view>
  </AppShell>
  <UiToasts />
  <UiConfirm />
  <MissingFieldsDialog />
  <UiTooltips />
  <PrivacyLayer />
</template>
